import routerOptions0 from "/home/leandro/_git/baeta-advocacia/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_better-sqlite3@11._2f7dydcu443ytkks3h3avydaau/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/leandro/_git/baeta-advocacia/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}